/**
 *  翻牌抽奖组件
 */

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import styles from "./style.module.less";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { Loading, Toast } from "@xp-design/mobile";
import { userPrizeDraw } from "@/api/configPage";
import useGetLoaclIp from "@/hooks/useGetLocalIP/useGetLoaclIp";
import { prizeDialogData } from "../../tool";
import NameList from "../../../nameList";
import CountDown from "../../../countDown";
import { processOssImage } from "@/utils/image";
import { useServerNow } from "@/hooks/useServerTimeSync";

interface FanpaiProps {
  pageInfo: any;
  activityInfo: any;
  activityStatusList: any;
  actInfo: any;
  showKeyIdx: number;
  onShowKeyIdx: Function;
  afterDraw?: (prizeData: any) => void;
}

interface FanpaiRef {
  onCloseDialog: () => void;
}

const Fanpai = forwardRef<FanpaiRef, FanpaiProps>(
  (
    {
      pageInfo,
      activityInfo,
      activityStatusList,
      actInfo,
      afterDraw,
      onShowKeyIdx,
      showKeyIdx,
    },
    ref,
  ) => {
    const serverNow = useServerNow();
    const { localIP } = useGetLoaclIp();
    const [showPrizeItem, setShowPrizeItem] = useState({
      prizeUrl: null,
      cardIndex: null,
      productName: null,
    });
    const isPlaying = useRef(false);

    const nameListRef = useRef<any>(null);
    const [downTime, setDownTime] = useState("");
    const [prizeMaskShow, setPrizeMaskShow] = useState(false);

    useEffect(() => {
      setDownTime(
        actInfo?.lotteryActivityDto?.activityEndTime?.replace(/-/g, "/"),
      );
    }, [actInfo]);

    const nameListCom = (isNeedBack = true) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[2]?.val === "1" && (
          <NameList
            isNeedBack={isNeedBack}
            activityCode={pageInfo?.base?.[0]?.val?.valCode}
            ref={nameListRef}
          />
        )
      );
    };

    const timeCountdown = (bgUrl) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[1]?.val === "1" &&
        serverNow >
          new Date(
            actInfo?.lotteryActivityDto?.activityBeginTime?.replace(/-/g, "/"),
          ).getTime() && <CountDown bgUrl={bgUrl} endTime={downTime} />
      );
    };

    const onCloseDialog = () => {
      onShowKeyIdx(-1);
      setShowPrizeItem({
        prizeUrl: showPrizeItem.prizeUrl,
        cardIndex: -1,
        productName: showPrizeItem.productName,
      });
    };

    useImperativeHandle(ref, () => ({
      onCloseDialog,
    }));

    // 点击抽奖
    const draw = async (cardIndex) => {
      if (isPlaying.current) {
        return;
      }
      trackGdp("P20189", "B004", {
        trackName: "充电_营销专题页_组件点击",
        origin: getChannel(),
        userType: "",
        versionId: activityInfo.versionCode,
        pageId: activityInfo.pageCode,
        ComponentCode: activityInfo.moduleId,
        type: activityInfo.moduleType,
        activityId: pageInfo.base[0].val.valCode,
        comp_style: JSON.parse(activityInfo.moduleJson).visual?.visualData[0]
          ?.typeName,
        status:
          activityStatusList[actInfo?.lotteryActivityDto?.activityStatus] || "",
        clickLocation: "抽奖按钮",
        remain_times: actInfo?.lotteryUserCountDto?.[0]?.remainingTimes,
      });
      if (actInfo?.lotteryUserCountDto?.[0]?.remainingTimes === 0) {
        Toast.show({
          content: "抽奖机会已用完，请做任务获得更多机会",
        });
        return;
      }
      isPlaying.current = true;
      setPrizeMaskShow(true);
      setContentOverflow(true);
      try {
        // Loading.show("加载中...");
        const res: any = await userPrizeDraw({
          activityCode: pageInfo.base[0].val.valCode,
          ip: localIP,
        });

        if (res.code === 200) {
          // 设置点击过的卡片
          const { productCode } = res.data;
          const prizeUrl = pageInfo?.prizes?.prizeData?.find(
            (item) => item.productCode === productCode,
          )?.val;
          const productName = pageInfo?.prizes?.prizeData?.find(
            (item) => item.productCode === productCode,
          )?.productName;
          onShowKeyIdx(showKeyIdx);
          setShowPrizeItem({
            prizeUrl,
            cardIndex,
            productName,
          });

          const pData = await new Promise((resolve) => {
            setTimeout(() => {
              resolve(prizeDialogData(res.data, pageInfo));
              // 抽奖 默认旋转时间为5秒 5秒后再展示中将结果
            }, 500);
          });

          afterDraw?.(pData);
          nameListRef?.current?.refresh(pageInfo?.base?.[0]?.val?.valCode); // 更新走马灯内容
        } else {
          Toast.show({
            content: res.msg,
          });
        }
      } catch (error: any) {
        console.log(error);
      } finally {
        // Loading.hide();
        isPlaying.current = false;
        setPrizeMaskShow(false);
        setContentOverflow(false);
      }
    };

    const setContentOverflow = (hidden: boolean) => {
      document.body.style.overflow = hidden ? "hidden" : "auto";
      document.body.style.pointerEvents = hidden ? "none" : "";
      const configPage = document.getElementById("configPage");
      if (configPage) {
        configPage.style.overflow = hidden ? "hidden" : "auto";
      }
    };

    return (
      <>
        {nameListCom()}
        {timeCountdown(pageInfo?.visual?.prizeSetting?.[0]?.content?.[7]?.val)}
        <div className={styles.fanpai}>
          <div className={styles.cardList}>
            {new Array(pageInfo.prizes?.prizeData?.length || 6)
              .fill(null)
              .map((item, index) => {
                // 有中奖图片 该给他翻正面了
                const { prizeUrl, productName, cardIndex } = showPrizeItem;
                return (
                  <div
                    style={{
                      marginTop: index > 2 ? `-${32}px` : "",
                      perspective: "1000px",
                    }}
                    onClick={() => {
                      // 点过了就不给点了
                      // if (prizeUrl) return
                      draw(index);
                    }}
                    key={`cardItem${index}`}
                  >
                    {/* 翻正面判断 */}
                    {cardIndex == index ? (
                      <>
                        <div
                          className={`${styles.cardItem} ${styles.front}`}
                          style={{
                            backgroundImage: `url(${processOssImage(pageInfo?.visual?.prizeSetting[0]?.content[5]?.val || "")})`,
                            backgroundSize: "100% 100%",
                            transform: "translateZ(0) rotateY(-180deg)",
                            WebkitTransform: "translateZ(0) rotateY(-180deg)",
                            backfaceVisibility: "hidden",
                          }}
                        >
                          {/* 正面 */}
                        </div>
                        <div
                          className={`${styles.cardItem} ${styles.back}`}
                          style={{
                            backgroundImage: `url(${processOssImage(pageInfo?.visual?.prizeSetting[0]?.content[6]?.val || "")})`,
                            backgroundSize: "100% 100%",
                            transform: "translateZ(1px) rotateY(0deg)",
                            WebkitTransform: "translateZ(1px) rotateY(0deg)",
                          }}
                        >
                          {/* 背面 */}
                          {prizeUrl && <img src={processOssImage(prizeUrl)} />}
                          <div className={styles.text}>{productName}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className={`${styles.cardItem} ${styles.front}`}
                          style={{
                            backgroundImage: `url(${processOssImage(pageInfo?.visual?.prizeSetting[0]?.content[5]?.val || "")})`,
                            backgroundSize: "100% 100%",
                            transform: "translateZ(0) rotateY(0deg)",
                            WebkitTransform: "translateZ(0) rotateY(0deg)",
                            backfaceVisibility: "hidden",
                          }}
                        >
                          {/* 正面 */}
                        </div>
                        <div
                          className={`${styles.cardItem} ${styles.back}`}
                          style={{
                            backgroundImage: `url(${processOssImage(pageInfo?.visual?.prizeSetting[0]?.content[6]?.val || "")})`,
                            backgroundSize: "100% 100%",
                            transform: "translateZ(1px) rotateY(180deg)",
                            WebkitTransform: "translateZ(1px) rotateY(180deg)",
                          }}
                        >
                          {/* 背面 */}
                          {prizeUrl && <img src={processOssImage(prizeUrl)} />}
                          <div className={styles.text}>{productName}</div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
          </div>

          {pageInfo?.elementSwitch?.switchData[0]?.val === "1" && (
            <div className={styles.drawNum}>
              <div>
                剩余{actInfo?.lotteryUserCountDto?.[0]?.remainingTimes || 0}次
              </div>
            </div>
          )}
        </div>
        {prizeMaskShow && <div className={styles.prizeMask}></div>}
      </>
    );
  },
);

export default Fanpai;
